import { renderAsync } from "docx-preview";

export const renderDocxFile = async (url: string, container: HTMLElement, className: string, inWrapper: boolean) => {
  const response = await fetch(url);
  const arrayBuffer = await response.arrayBuffer();

  await renderAsync(arrayBuffer, container, undefined, {
    className,
    inWrapper,
  });
};
